<template>
  <div class="textarea" :class="{hoverClass:true, 'disable-edit': showDisableClass}"
       :contenteditable="canEditable"
       v-html="innerText"
       @input="changeText"
       @blur="onBlur"
       @dblclick="copyContentToClipboard($event)"
  ></div>
</template>

<script>
const clipboard = require('clipboard-polyfill')
export default {
  name: 'edit-div-cell',
  props: {
    value: {
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    },
    cellEditable: { type: Boolean, default: true },
    clipboardCopy: { type: Boolean, default: false }
  },
  data () {
    return {
      innerText: this.value,
      hoverClass: 'n-hover'
    }
  },
  computed: {
    canEditable () {
      if (!this.editable) {
        return this.cellEditable
      } else {
        return false
      }
    },
    showDisableClass () {
      return !this.editable && !this.canEditable
    }
  },
  methods: {
    onBlur () {
      this.$emit('on-blur')
    },
    changeText () {
      this.$emit('input', this.$el.innerText.trim())
    },
    copyContentToClipboard () {
      if (this.clipboardCopy) {
        clipboard.writeText(this.$el.innerText)
        this.$emit('on-cell-content-copy', this.$el.innerText)
      }
    }
  },
  watch: {
    editable: function (val) {
      if (!this.editable) {
        this.hoverClass = 'd-hover'
      } else {
        this.hoverClass = 'n-hover'
      }
    }
  }
}
</script>

<style scoped>
  .textarea{
    width: 100%;
    min-height: 38px;
    margin: 1px auto;
    outline: 0;
    font-size: 12px;
    line-height: 24px;
    padding: 2px;
    word-wrap: break-word;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-user-select:text;
  }
  .d-hover:hover {
    background-color: #E8E8E8;
    cursor: text;
  }
  .disable-edit {
    background-color: #f3f3f3;
    opacity: 1;
    cursor: not-allowed;
    color: #ccc;
  }
</style>
